export type SectionTopic = {
  label: string
  anchor: string
}

export type SectionEntry = {
  number: string
  name: string
  navLabel: string
  path: string
  summary: string
  contains: SectionTopic[]
}

export const introPath = '/'

export const sections: SectionEntry[] = [
  {
    number: '01',
    name: 'About',
    navLabel: 'About',
    path: '/about',
    summary:
      'Who Yolandi Jardim is: professional biography, leadership philosophy and the principles that shape her executive practice.',
    contains: [
      { label: 'Biography', anchor: '#biography' },
      { label: 'Profile at a glance', anchor: '#biography' },
      { label: 'Leadership philosophy', anchor: '#philosophy' },
    ],
  },
  {
    number: '02',
    name: 'Experiences',
    navLabel: 'Experiences',
    path: '/experiences',
    summary:
      'The industries, regulatory environments and engagement types across which she has operated as an executive.',
    contains: [
      { label: 'Industry exposure', anchor: '#industry' },
      { label: 'Regulatory environments', anchor: '#regulatory' },
      { label: 'Engagement types', anchor: '#engagement' },
    ],
  },
  {
    number: '03',
    name: 'Skills',
    navLabel: 'Skills',
    path: '/skills',
    summary:
      'Executive and human capabilities, covering leadership, influence, change and capability building, assessed by depth of practice.',
    contains: [
      { label: 'Executive leadership', anchor: '#executive-leadership' },
      { label: 'Influence & communication', anchor: '#influence-communication' },
      { label: 'Change & delivery', anchor: '#change-delivery' },
      { label: 'People & capability', anchor: '#people-capability' },
    ],
  },
  {
    number: '04',
    name: 'Executive Impact & Capital Metrics',
    navLabel: 'Impact Metrics',
    path: '/impact',
    summary:
      'Quantified outcomes: capital deployed, assets governed, remediation closure and audit results.',
    contains: [
      { label: 'Headline outcomes', anchor: '#headline-outcomes' },
      { label: 'Capital metrics', anchor: '#capital-metrics' },
    ],
  },
  {
    number: '05',
    name: 'Strategic Value Proposition & Board Competencies',
    navLabel: 'Value & Competencies',
    path: '/value-proposition',
    summary:
      'The value she brings to a board table, expressed as four leadership pillars and mapped board competencies.',
    contains: [
      { label: 'Value proposition', anchor: '#proposition' },
      { label: 'Four pillars', anchor: '#pillars' },
      { label: 'Board competency map', anchor: '#competencies' },
    ],
  },
  {
    number: '06',
    name: 'Executive Career Track Record',
    navLabel: 'Career Record',
    path: '/career',
    summary:
      'Chronological record of executive appointments, mandates held and accomplishments delivered in each.',
    contains: [
      { label: 'Executive appointments', anchor: '#appointments' },
      { label: 'Earlier leadership', anchor: '#earlier' },
    ],
  },
  {
    number: '07',
    name: 'Technical Mastery & Systems Portfolio',
    navLabel: 'Technical Mastery',
    path: '/technical',
    summary:
      'Frameworks, standards, platforms and architectures she has implemented and governed at enterprise scale.',
    contains: [
      { label: 'Frameworks & tooling', anchor: '#mastery' },
      { label: 'Systems portfolio', anchor: '#portfolio' },
    ],
  },
  {
    number: '08',
    name: 'Board Experience, Education & Civic Leadership',
    navLabel: 'Board & Education',
    path: '/board-education',
    summary:
      'Council and committee service, formal qualifications and certifications, and contribution beyond the organisation.',
    contains: [
      { label: 'Board & committee service', anchor: '#board-service' },
      { label: 'Education & certification', anchor: '#education' },
      { label: 'Civic leadership', anchor: '#civic' },
    ],
  },
  {
    number: '09',
    name: 'Board Inquiry & Direct Contact Portal',
    navLabel: 'Contact Portal',
    path: '/contact',
    summary:
      'Direct contact channels, availability for NED and advisory engagement, and a structured board inquiry form.',
    contains: [
      { label: 'Direct contact', anchor: '#direct-contact' },
      { label: 'Board inquiry form', anchor: '#inquiry' },
    ],
  },
]

export function sectionByPath(path: string): SectionEntry | undefined {
  return sections.find((section) => section.path === path)
}

export function adjacentSections(path: string) {
  const index = sections.findIndex((section) => section.path === path)
  return {
    previous: index > 0 ? sections[index - 1] : undefined,
    next: index >= 0 && index < sections.length - 1 ? sections[index + 1] : undefined,
  }
}
